import {
  principal_svg
} from './svg_icons';
import { actualizarFactorIntegracion } from '../Operaciones/Funciones/ActualizarFI';
//Iconos para los menús principales
import AdminPrenomina from '../../styles/img/iconosNew/AdminPrenomina.svg';
import Clientes from '../../styles/img/iconosNew/Clientes.svg';
import Configuracion from '../../styles/img/iconosNew/Configuracion.svg';
import Empleados from '../../styles/img/iconosNew/Empleados.svg';
import Empresas from '../../styles/img/iconosNew/Empresas.svg';
import Facturacion from '../../styles/img/iconosNew/Facturacion.svg';
import Finiquitos from '../../styles/img/iconosNew/Finiquitos.svg';
import Prenomina from '../../styles/img/iconosNew/Prenomina.svg';
import Remision from '../../styles/img/iconosNew/Remision.svg';
//Iconos para el menú Configuración
import Contraseñas from '../../styles/img/iconosNew/Configuración_Contraseñas.svg';
import ISN from '../../styles/img/iconosNew/Configuración_ISN.svg';
import ISR from '../../styles/img/iconosNew/Configuración_ISR.svg';
import Plazas from '../../styles/img/iconosNew/Configuración_Plazas.svg';
import Puestos from '../../styles/img/iconosNew/Configuración_Puestos.svg';
import Salario from '../../styles/img/iconosNew/Configuración_Salario.svg';
import UMA from '../../styles/img/iconosNew/Configuración_UMA.svg';
import UMI from '../../styles/img/iconosNew/Configuración_UMI.svg';
import Usuarios from '../../styles/img/iconosNew/Configuración_Usuarios.svg';
import Sindicato from '../../styles/img/iconosNew/Configuración_Sindicato.svg';
//Iconos para Agregar y Listar
import Agregar from '../../styles/img/iconosNew/Agregar.svg';
import Listar from '../../styles/img/iconosNew/Listar.svg';
import DescargarDoc from '../../styles/img/iconosNew/DescargarDoc.svg';
//Iconos para el menú Administrar Nómina
import DAjuste from '../../styles/img/iconosNew/AdminNómina_DíaAjuste.svg';
import ExceDiasHoras from '../../styles/img/iconosNew/AdminNómina_ExcepciónDíasHoras.svg';
import ExceMontos from '../../styles/img/iconosNew/AdminNómina_ExcepciónMontos.svg';
import FaltasExtras from '../../styles/img/iconosNew/AdminNómina_FaltasExtras.svg';
import Incapacidades from '../../styles/img/iconosNew/AdminNómina_Incapacidades.svg';
import Permisos from '../../styles/img/iconosNew/AdminNómina_Permisos.svg';
import Vacaciones from '../../styles/img/iconosNew/AdminNómina_Vacaciones.svg';
//Iconos para el menú de Finiquitos
import Liquidacion from '../../styles/img/iconosNew/Finiquitos_Liquidacion.svg';
import Renuncia from '../../styles/img/iconosNew/Finiquitos_Renuncia.svg';
import Plantilla from '../../styles/img/iconosNew/Plantilla-73.svg';
import Prestaciones from '../../styles/img/iconosNew/Prestaciones.svg';
import ProcesarNomina from '../../styles/img/iconosNew/ProcesarNomina.svg';


export const menuItems = [
  {
    label: 'Principal',
    svg: principal_svg
  },
  {
    svg: Empresas,
    label: 'Empresas',
    roles: ['Administrador', 'AG', 'Mesa de Control'],
    subMenus: [
      {
        route: '/catalogos/empresas/wizar',
        icon: Agregar,
        label: 'Agregar',
        roles: ['Administrador', 'AG', 'Mesa de Control']
      },
      {
        route: '/catalogos/empresas',
        icon: Listar,
        label: 'Listar',
        roles: ['Administrador', 'AG', 'Mesa de Control']
      }
    ]
  },
  // {
  //   svg: Empleados,
  //   label: 'Empleados',
  //   roles: ['AG', 'Cliente', 'Ejecutivo Nómina', 'Administrador'],
  //   subMenus: [
  //     {
  //       route: '/portalCliente/empleados',
  //       icon: Listar,
  //       label: 'Listar',
  //       roles: ['AG', 'Cliente', 'Ejecutivo Nómina', 'Administrador']
  //     }
  //   ]
  // },
  {
    svg: Clientes,
    label: 'Clientes',
    roles: ['Administrador', 'AG', 'Ejecutivo Nómina','Mesa de Control'],
    subMenus: [
      {
        route: '/catalogos/clientes/agregar',
        icon: Agregar,
        label: 'Agregar',
        roles: ['Administrador', 'AG', 'Mesa de Control']
      },
      {
        route: '/catalogos/clientes/listar',
        icon: Listar,
        label: 'Listar',
        roles: ['Administrador', 'Interaxis', 'Ejecutivo Nómina','Mesa de Control']
      },
      {
        route: '/portalCliente/empleados',
        icon: Empleados,
        label: 'Empleados',
        roles: ['AG', 'Cliente', 'Ejecutivo Nómina', 'Administrador']
      }
    ]
  },
  {
    svg: Prenomina,
    label: 'Prenómina',
    roles: ['Administrador', 'AG', 'Cliente', 'Ejecutivo Nómina'],
    subMenus: [
      {
        route: '/portalCliente/prenominaCliente/agregar',
        icon: Agregar,
        label: 'Agregar',
        roles: ['Administrador', 'AG', 'Cliente', 'Ejecutivo Nómina']
      },
      {
        route: '/portalCliente/prenominaCliente',
        icon: Listar,
        label: 'Listar',
        roles: ['Administrador', 'AG', 'Cliente', 'Ejecutivo Nómina']
      },
      {
        route: '/portalCliente/operacionesNomina',
        icon: Listar,
        label: 'Operaciones',
        roles: ['Administrador', 'AG', 'Cliente', 'Ejectuvi Nómina']
      },
      {
        route: '/portalCliente/recibosDeNomina',
        icon: DescargarDoc,
        label: 'Recibos de nómina',
        roles: ['Administrador', 'AG', 'Cliente', 'Ejecutivo Nómina']
      }
    ]
  },
  {
    svg: Prenomina,
    label: 'Reportes',
    roles: ['Administrador', 'AG', 'Ejecutivo Nómina'],
    url: '/reportes'
  },
  {
    svg: AdminPrenomina,
    label: 'Administrar Nómina',
    roles: ['Administrador', 'AG', 'Cliente', 'Ejecutivo Nómina'],
    subMenus: [
      {
        route: '/prenomina/faltas',
        icon: FaltasExtras,
        label: 'Faltas y Extras',
        roles: ['AG']
      },
      {
        route: '/prenomina/incapacidades',
        icon: Incapacidades,
        label: 'Incapacidades',
        roles: ['Administrador', 'AG', 'Cliente', 'Ejecutivo Nómina']
      },
      {
        route: '/prenomina/permisos',
        icon: Permisos,
        label: 'Permisos',
        roles: ['AG']
      },
      {
        route: '/prenomina/diaAjustes',
        icon: DAjuste,
        label: 'Día Ajuste',
        roles: ['AG']
      },
      {
        route: '/prenomina/vacaciones',
        icon: Vacaciones,
        label: 'Vacaciones',
        roles: ['Administrador', 'AG', 'Cliente', 'Ejecutivo Nómina']
      },
      {
        route: '/prenomina/excepcionMontos',
        icon: ExceMontos,
        label: 'Excepción de Montos',
        roles: ['AG']
      },
      {
        route: '/prenomina/diasHoras',
        icon: ExceDiasHoras,
        label: 'Excepción Días y Horas',
        roles: ['AG']
      }
    ]
  },
  // {
  //   svg: operaciones_svg,
  //   label: 'Operaciones',
  //   roles: [
  //     'Administrador',
  //     'AG',
  //     'Ejecutivo Nómina',
  //     'Dispercion',
  //     'Cuentas por cobrar',
  //   ],
  //   subMenus: [
  //     {
  //       route: '/operaciones/calculoNomina',
  //       icon: 'fas fa-file-invoice-dollar',
  //       label: 'Procesar Nómina',
  //       roles: ['Administrador', 'AG', 'Ejecutivo Nómina']
  //     }
  //   ]
  // },
  // {
  //   svg: facturacion_svg,
  //   label: 'Facturación',
  //   subMenus: []
  // }
  {
    svg: Finiquitos,
    label: 'Finiquitos',
    roles: ['Administrador', 'AG', 'Cliente', 'Ejecutivo Nómina'],
    subMenus: [
      {
        route: '/portalCliente/finiquitoRenuncia',
        icon: Renuncia,
        label: 'Renuncia',
        roles: ['Administrador', 'AG', 'Cliente', 'Ejecutivo Nómina']
      },
      {
        route: '/portalCliente/finiquito',
        icon: Liquidacion,
        label: 'Liquidación',
        roles: ['Administrador', 'AG', 'Cliente', 'Ejecutivo Nómina']
      }
    ]
  },
  {
    svg: Remision,
    label: 'Remisiones',
    roles: ['Administrador', 'AG', 'Ejecutivo Nómina', 'Ejecutivo Tesoreria'],
    subMenus: [
      {
        route: '/catalogos/remisiones',
        icon: ISR,
        label: 'Remisiones',
        roles: ['Administrador', 'AG', 'Ejecutivo Nómina', 'Ejecutivo Tesoreria']
      }
    ]
  },
  {
    svg: Facturacion,
    label: 'Facturación y Tickets',
    roles: ['Administrador', 'AG', 'Ejecutivo Nómina', 'Cliente', 'Ejecutivo Tesoreria','Facturación'],
    subMenus: [
      {
        route: '/catalogos/facturas',
        icon: Listar,
        label: 'Listar',
        roles: ['Administrador', 'AG', 'Ejecutivo Nómina', 'Cliente', 'Ejecutivo Tesoreria', 'Facturación'],
      },
      {

        route: '/catalogos/auditoria',
        icon: Listar,
        label: 'Auditoria',
        roles: ['Administrador', 'AG', 'Ejecutivo Nómina', 'Cliente', 'Ejecutivo Tesoreria', 'Facturación'],

      }
    ]


  },
  {
    svg: Configuracion,
    label: 'Configuración',
    roles: ['Administrador', 'AG', 'Mesa de Control'],
    subMenus: [
      {
        route: '/catalogos/usuarios',
        icon: Usuarios,
        label: 'Usuarios',
        roles: ['Administrador', 'AG', 'Mesa de Control']
      },
      {
        route: '/catalogos/umas',
        icon: UMA,
        label: 'UMA',
        roles: ['AG']
      },
      {
        route: '/catalogos/umis',
        icon: UMI,
        label: 'UMI',
        roles: ['AG']
      },
      {
        route: '/catalogos/salarioMinimo',
        icon: Salario,
        label: 'Salario Mínimo',
        roles: ['AG']
      },
      {
        route: '/catalogos/puestos',
        icon: Puestos,
        label: 'Puestos Sherpa',
        roles: ['AG', 'Administrador', 'Mesa de Control']
      },
      {
        route: '/catalogos/isr',
        icon: ISR,
        label: 'ISR  y Cuota IMSS',
        roles: ['AG']
      },
      {
        route: '/catalogos/isn',
        icon: ISN,
        label: 'ISN',
        roles: ['AG']
      },
      {
        route: '/catalogos/plazas',
        icon: Plazas,
        label: 'Plazas',
        roles: ['AG', 'Administrador', 'Mesa de Control']
      },
      {
        route: '/catalogos/contrasenas',
        icon: Contraseñas,
        label: 'Contraseñas',
        roles: ['AG', 'Administrador']
      },
      {
        route: '/catalogos/sindicatos',
        icon: Sindicato,
        label: 'Sindicatos',
        roles: ['AG', 'Administrador']
      },
      {
        route: '/catalogos/plantillas',
        icon: Plantilla,
        label: 'Plantillas',
        roles: ['AG']
      },
      {
        route: '/catalogos/comisionReporte',
        icon: Prestaciones,
        label: 'Comisión Reporte ID',
        roles: ['AG', 'Administrador']
      },
      {
        route: '/portalCliente/empleados',
        icon: ProcesarNomina,
        label: 'Actualizar FI',
        roles: ['AG'],
        action: () => { actualizarFactorIntegracion();}
      },
      {
        route: '/catalogos/configuracionNomina',
        icon: ProcesarNomina,
        label: 'Configuración Nómina',
        roles: ['AG', 'Administrador']
      }
    ]
  },
];
